<template>
  <SharePermissions
    :is-loading="pending"
    :readonly="readonly"
    :is-shared="!!profile?.isShared"
    :permissions="profile?.sharedTo || []"
    @toggle="toggleIsShared"
    @add="addShare"
    @remove="removeShare"
    @edit="editShare"
  />
  <ButtonWithLoader
    v-if="!isSharedWithSupport && profile?.isMine"
    class="pb-quarter-margin-top"
    @click="shareWithSupport"
  >
    {{ translate('pb2.shareForm.shareWithSupport') }}
  </ButtonWithLoader>
</template>

<script setup>
import ButtonWithLoader from '@/components/ButtonWithLoader.vue'
import { useProfile, useProfileStatus } from '@/composables/useProfile'
import useTranslate from '@/composables/useTranslate'
import config from '@/config'
import useProfileStore from '@/stores/profile.store'
import SharePermissions from '@nicolaudie-group/ng-ui-kit/components/Sharing/SharePermissions.vue'
import { computed } from 'vue'

const { translate } = useTranslate()

const profile = useProfile()
const { pending } = useProfileStatus()
const profileStore = useProfileStore()

const readonly = computed(() => !profile.value.userCanManage)

const isSharedWithSupport = computed(() => {
  const result = (
    profile.value
    && profile.value.sharedTo
    && profile.value.sharedTo.find((share) => share.userEmail === config.shares.support)
  )

  return result
})

async function toggleIsShared(newState) {
  if (!readonly.value) {
    await profileStore.edit({ isShared: newState })
  }
}

async function addShare(userEmail, payload = {}) {
  if (!readonly.value) {
    await profileStore.share({ ...payload, userEmail })
  }
}

function shareWithSupport() {
  return addShare(config.shares.support)
}

async function editShare(userEmail, payload = {}) {
  if (!readonly.value) {
    await profileStore.editShare({ ...payload, userEmail })
  }
}

async function removeShare(userEmail) {
  if (!readonly.value) {
    await profileStore.deleteShare(userEmail)
  }
}
</script>
